<template>
  <v-container fluid>
    <v-snackbar
      v-model="snackbar"
      :color="snackbarColor"
      :top="true"
      :right="true"
      :timeout="6000"
      absolute
    >
      {{ message }}
      <v-btn dark text @click="snackbar = false"> CLOSE</v-btn>
    </v-snackbar>
    <v-layout mb-1>
      <v-flex xs12>
        <h2 class="white--text">Invoices</h2>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex xs12>
        <div
          :class="
            paginatedItems.length === 7 ? 'invoice_box' : 'invoice_box_empty'
          "
        >
          <v-card-text>
            <v-layout>
              <v-flex xs3>
                <span
                  class="accent--text"
                  style="font-size: 14px; font-weight: 700"
                >
                  Confirmed Invoices
                </span>
              </v-flex>
              <v-spacer></v-spacer>
              <v-flex xs3>
                <v-text-field label="Search" v-model="searchQuery" @input="handleSearchInput"></v-text-field>
              </v-flex>
            </v-layout>
            <v-data-table  :headers="confirmedHeaders" :items="filteredList" item-key="id"
                          class="elevation-1" :loading="loading"  hide-default-footer >
              <template v-slot:item="props">
                <tr :key="props.item.id" >
                  <td>{{ props.item?.invoiceNumber }}</td>
				<td>{{ props.item?.lot }}</td>
                  <td>
                    {{ props.item?.marketerName != null ? props.item?.marketerName : "" }}
                  </td>
                  <td>{{ props.item?.buyerName != null ? props.item?.buyerName : "" }}</td>
                  <td>{{ props.item?.growerName != null ? props.item?.growerName : "" }}</td>

                  <td>{{ props.item?.grossValue }}</td>
                  <td>{{ props.item?.totalDeductions}}</td>
                  <td>{{ props.item?.netPay}}</td>

                  <td  class="actions">
                    <v-menu offset-y>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          color="secondary"
                          dark
                          v-on="on"
                          text
                          icon
                          class="actions"
                        >
                          <v-icon medium> more_horiz</v-icon>
                        </v-btn>
                      </template>
                      <v-list>



                        <v-list-item @click="triggerDownload(props.item)">
                          <v-list-item-title> Download</v-list-item-title>
                        </v-list-item>

                      </v-list>
                    </v-menu>
                  </td>
                </tr>
              </template>

            </v-data-table>


            <v-card-actions>
              <v-row>
                <v-col cols="12" sm="9">
                  <v-pagination
                    v-model="page"
                    :length="totalPages"
                    total-visible="numberOfItemsPerPage"
                    next-icon="mdi-menu-right"
                    prev-icon="mdi-menu-left"
                    @input="handlePageChange"
                  ></v-pagination>
                </v-col>
              </v-row>
              <v-spacer></v-spacer>
              <!-- <span class="paginationtext"> Showing {{ page }} of {{ numberOfLinks }} pages </span> -->
              <v-spacer></v-spacer>
              <v-pagination
                v-model="page"
                :length="numberOfLinks"
                :total-visible="7"
                color="accent"
              ></v-pagination>
            </v-card-actions>
          </v-card-text>
        </div>
      </v-flex>

    </v-layout>
  </v-container>
</template>
<script>
import axios from 'axios'
import config from '../../../config'
import store from '../../../store'
import _ from 'lodash'

export default {
	name: 'viewinvoice',
	data: function () {
		return {
			invoiceHeaders: [
				{ text: 'Id', value: 'invoiceNumber' },
				{ text: 'lot Number', value: 'lotNumber' },
				{ text: 'OutTurn', value: 'catalogue.outTurn' },
				{ text: 'Grade', value: 'grade' },
				{ text: 'Bags', value: 'bagsBought' },
				{ text: 'Weight', value: 'weightBought' },
				{ text: 'Price Per Bag', value: 'price' },
				{ text: 'Value(USD)', value: 'totalValue' },
				{ text: 'Invoice Date', value: 'created' }
			],
			confirmedHeaders: [
				{ text: 'InvoiceID', value: 'invoiceNumber' },
				{ text: 'lot Number', value: 'lot' },
				{ text: 'Marketer.', value: 'marketerName' },
				{ text: 'Buyer', value: 'buyerName' },
				{ text: 'Grower', value: 'growerName' },
				{ text: 'Value(USD)', value: 'grossValue' },
				{ text: 'Deductions(USD)', value: 'totalDeductions' },
				{ text: 'NetPay(USD)', value: 'netPay' },
				// { text: 'Status', value: 'statusName' },

				{ text: 'Actions', value: 'actions' }],
			data: [],
			itemInvoices: [],
			singleInvoice: [],
			message: '',
			loading: false,
			pagination: {},
			snackbar: false,
			snackbarColor: '',
			dialog: false,
			paginatedItems: [],
			numberOfLinks: 0,
			numberOfItemsPerPage: window.innerHeight <= 600 ? 6 : window.innerHeight > 600 && window.innerHeight <= 1000 ? 14 : 20,
			currentPage: 0,
			page: 1,

			search: '',
			totalPages: 0,
			pageSize: 7,
			pageSizes: [5, 10],
			invoiceId: '',
			id: '',
			marketer: '',
			buyer: '',
			value: '',
			status: '',
			statusId: '',
			newstatus: '',
			newstatusId: '',
			searchQuery:'',
			editedItem: {
				id: '',
				lotNumber: '',
				actionComment: ''
			},
			statusOptions: [
				// { id: 1, name: "Pending" },
				// { id: 2, name: "Approved" },
				// { id: 3, name: "Rejected" },
				{ id: 7, name: 'PAID' },
				{ id: 9, name: 'PARTIALLY-PAID' },
				{ id: 0, name: 'REJECTED' },
				{ id: 60, name: 'MANUAL_SETTLED_PA' }
				// { id: 5, name: "Completed" },
			]
		}
	},
	mounted () {
		this.getApprovedInvoices(this.currentPage)
		this.permissions = store.state.user.roleId.permissions
	},
	watch: {
		invoices () {
			this.paginatedItems = this.data
		},
		page: function (val) {
			this.paginatedItems = this.getApprovedInvoices(val - 1)
			// this.paginationMethod(
			// 	this.invoices,
			// 	val,
			// 	this.numberOfItemsPerPage
			// )
		}
	},
	computed: {
		filteredList: function () {
			if (this.search === '') {
				return this.paginatedItems // Return all items when search is empty
			} else {
				const searchTerm = this.search.toLowerCase()
				return this.data.filter((result) => {
					var dateCreated = new Date(result.created)
					// Check if the search term is found in any of the columns
					return (
						result.id.toString().includes(searchTerm) ||
            (result.marketerName &&
              result.marketerName.toLowerCase().includes(searchTerm)) ||
            (result.buyerName &&
              result.buyerName.toLowerCase().includes(searchTerm)) ||
            result.grossValue.toString().includes(searchTerm) ||
            // result.dateCreated.toLowerCase().includes(searchTerm) ||
            result.statusName.toLowerCase().includes(searchTerm) ||
            dateCreated.toDateString().toLowerCase().includes(searchTerm)
					)
				})
			}
		}

	},
	methods: {
		handleSearchInput(){
			this.getApprovedInvoices(this.currentPage)
		},
		hasPerm (permission) {
			return this.permissions.includes(permission)
		},
		canBeDeleted (item) {
			return item.statusId === 5 || item.statusId === 4
		},






		paginationMethod (items, pageNumber, limitPerPage) {
			pageNumber = pageNumber - 1
			const from = pageNumber * limitPerPage
			let to = (pageNumber + 1) * limitPerPage
			if (to >= items.length) {
				to = items.length
			}
			return items.slice(from, to)
		},
		getRequestParams (name, page, pageSize) {
			const params = {}
			// if (page) {
			params.page = page
			params.query = this.searchQuery			// - 1
			// }
			// if (pageSize) {
			params.size = pageSize
			// }
			if (name) {
				params.eslipNumber = name
			}
			return params
		},
		updateStatusId (selectedStatus) {
			const selectedStatusObject = this.statusOptions.find(
				(option) => option.name === selectedStatus
			)

			if (selectedStatusObject) {
				this.statusId = selectedStatusObject.id
			} else {
				// Handle the case where the selectedStatus is not found in statusOptions
				// console.error('Selected status not found:', selectedStatus)
			}
		},
		getApprovedInvoices (val) {
			this.loading = true
			const params = this.getRequestParams(
				this.searchQuery,
				val,
				this.numberOfItemsPerPage
			)
			const url = config.serverURI + '/invoice/GROWER_BROKER'

			axios
				.get(url, { params })
				.then((response) => {
					this.invoices = response.data.content
					this.numberOfLinks = response.data.page.totalPages
					this.numberOfItemsPerPage = response.data.page.size
					this.currentPage = response.data.page.number
					this.loading = false
				})
				.catch((error) => {
					// Request failed.
					this.message = error.response.status
					this.snackbar = true
					this.snackbarColor = 'error'
					this.loading = false
				})
			return this.data
		},
		handlePageChange (value) {
			this.page = value
			this.getApprovedInvoices()
		},
		handlePageSizeChange (size) {
			this.pageSize = size
			this.page = 1
			this.getApprovedInvoices()
		},
		created: function () {
			this.debouncedGetAnswer = _.debounce(this.getSettlements, 1000)
		},
		showInvoices (item) {
			this.dialog = true
			this.itemInvoices = item.auctionResults
		},
		triggerDownload (item) {
			console.log(item.data)
			const url = config.serverURI + '/invoice/stakeholder/download'
			axios({ url: url, method: 'POST', responseType: 'blob', data: item })
				.then((response) => {
					const url = window.URL.createObjectURL(
						new Blob([response.data], { type: 'application/pdf' })
					)
					const link = document.createElement('a')
					link.href = url
					const itemFileName = item.buyerName + '_' + item.dateCreated + '.pdf'
					link.setAttribute('download', itemFileName)
					document.body.appendChild(link)
					link.click()
				})
				.catch((error) => {
					// Request failed.
					console.log('error', error.response)
					this.message = 'Error occurred'
					this.snackbar = true
					this.snackbarColor = 'error'
				})
		},
		triggerDownloadWithoutLevy (item) {
			console.log(item.data)
			const url = config.serverURI + '/invoice/downloadWithNoLevy'
			axios({ url: url, method: 'POST', responseType: 'blob', data: item })
				.then((response) => {
					const url = window.URL.createObjectURL(
						new Blob([response.data], { type: 'application/pdf' })
					)
					const link = document.createElement('a')
					link.href = url
					const itemFileName = item.buyerName + '_' + item.dateCreated + '.pdf'
					link.setAttribute('download', itemFileName)
					document.body.appendChild(link)
					link.click()
				})
				.catch((error) => {
					// Request failed.
					console.log('error', error.response)
					this.message = 'Error occurred'
					this.snackbar = true
					this.snackbarColor = 'error'
				})
		},
		submitInvoice () {
			console.log('Status before submitting>>>', this.status)
			const formData = {
				id: this.invoiceId,
				marketerName: this.marketer,
				buyerName: this.buyer,
				invoiceAmount: this.value,
				statusName: this.status,
				statusId: this.statusId // Assuming this property corresponds to the selected status
				// Add other form fields as needed
			}
			this.submitInvoiceDetails(formData)

			// Perform any submission logic here
			// You can access the form values using this.invoiceId, this.marketer, etc.
			// For example, you may want to send the data to the server.
			// After submission, you can close the dialog.
			this.closeDialog()
		},
		rejectInvoice () {
			const formData = {
				id: this.invoiceId,
				marketerName: this.marketer,
				buyerName: this.buyer,
				invoiceAmount: this.value,
				statusName: this.status,
				statusId: this.statusId // Assuming this property corresponds to the selected status
				// Add other form fields as needed
			}
			console.log('formData>>>>', formData)
			this.rejectInvoiceDetails(formData)

			// Perform any submission logic here
			// You can access the form values using this.invoiceId, this.marketer, etc.
			// For example, you may want to send the data to the server.
			// After submission, you can close the dialog.
			this.closeDialog()
		},
		submitapproveInvoice () {
			console.log('Status before submitting>>>', this.status)
			const formData = {
				id: this.invoiceId,
				marketerName: this.marketer,
				buyerName: this.buyer,
				invoiceAmount: this.value,
				statusName: this.newstatus,
				statusId: this.newstatusId // Assuming this property corresponds to the selected status
				// Add other form fields as needed
			}
			console.log('formData>>>>', formData)
			this.submitapproveInvoiceDetails(formData)

			// Perform any submission logic here
			// You can access the form values using this.invoiceId, this.marketer, etc.
			// For example, you may want to send the data to the server.
			// After submission, you can close the dialog.
			this.closeDialog()
		},
		closeDialog () {
			// Reset form values and close the dialog
			this.$refs.invoiceForm.reset()
			this.editInvoiceDialog = false
		},
		closeDeleteDialog () {
			// Reset form values and close the dialog
			this.$refs.invoiceForm.reset()
			this.deleteInvoiceDialog = false
		}
	}
}
</script>
<style>
.mytable .v-table tbody tr:not(:last-child) {
  border-bottom: none;
}

.invoice_box_empty {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}

.invoice_box {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}

.invoice_box:after,
.invoice_box:before {
  right: 100%;
  top: 39%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.invoice_box:after {
  border-color: rgba(255, 255, 255, 0);
  border-right-color: #fff;
  border-width: 20px;
  margin-top: -20px;
}

.invoice_box:before {
  border-color: rgba(112, 112, 112, 0);
  border-right-color: #707070;
  border-width: 21px;
  margin-top: -21px;
}

.tabs {
  font-weight: 600;
  font-color: #4e4e4e;
}

.loader {
  font-weight: 600;
  font-color: #4e4e4e;
  margin: 10px;
  font-size: 20px;
}
</style>
